var render, staticRenderFns
import script from "./ResizeAuto.vue?vue&type=script&lang=js"
export * from "./ResizeAuto.vue?vue&type=script&lang=js"
import style0 from "./ResizeAuto.vue?vue&type=style&index=0&id=4a4bb152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4bb152",
  null
  
)

export default component.exports